<template>
  <v-card 
    v-if="contract" 
    class="budget-modal-card mb-2"
    ref="contractHeaderInfo"
    :style="isScrolled ? {
      position: 'sticky',
      top: '0px',
      left: '0',
      right: '0',
      zIndex: 5
    } : {}"
  >
    <v-card-text :class="showProjectDetails ? 'pb-2 pt-0' : 'py-0'">
			<div class="project-header" :class="{ 'mb-2': showProjectDetails }">
				
				<span class="project-type-badge">{{ contractTypeText }}</span>

				<div class="project-info">
					<p class="project-code mb-0">{{ contractCode }}</p>
					<p class="project-name mb-0">{{ project?.name }}</p>
					<p class="project-name mb-0"><b>Direccion:</b> {{ project?.info?.address?.address }}</p>
				</div>

				<div class="status-notice-box" v-if="!hideContractStatus && contract.last_status?.status == contractStatuses.FIRMADO_CONTRAPARTE">
					<div>
						<v-icon small color="#FB8C00" class="mr-1" style="flex-shrink:0">mdi-alert-outline</v-icon>
						<span class="caption font-weight-bold status-notice-text">{{ statusNotice }}</span>
						<span class="caption status-notice-text">
							— Sólo el representante legal puede firmar el {{ contractTypeText }}{{ canSignCompany ? '' : ', con tu perfil no podrás realizar esta acción' }}
						</span>
					</div>
				</div>

				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<button class="toggle-btn" v-bind="attrs" v-on="on" @click="toggleShowDetail()">
							<v-icon>{{ localShowDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
							<span>{{ showProjectDetails ? 'Ocultar' : 'Ver' }} detalles</span>
						</button>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>

			</div>
      <div v-if="showProjectDetails" class="d-flex justify-space-between align-start w-100" :class="$vuetify.breakpoint.width < 750 ? 'flex-column' : 'flex-row'">
        <!-- Project Information Column -->
        <div class="flex-grow-1" :style="$vuetify.breakpoint.width < 750 ? 'width: 100%;' : ''">
          <div class="caption">

            <!-- Contract Number -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">{{ contractTypeText }}</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">
									{{ contractCode }}
                </b>
              </div>
              <div class="action-container">
								<div v-if="toContractDetail">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												dark
												x-small
												color="warning"
												@click="toContractDetail"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<span>Ir al Contrato Asociado</span>
									</v-tooltip>
								</div>
								<div>
									<v-menu 
										v-model="prefixMenu" 
										offset-y 
										z-index="9999" 
										:close-on-content-click="false" 
										content-class="menu-bg-white"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-btn
														icon
														color="warning"
														x-small
														:disabled="!canEditInfo"
														v-bind="{ ...attrs, ...tooltipAttrs }"
														v-on="{ ...on, ...tooltipOn }"
													>
														<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
													</v-btn>
												</template>
												<span>Cambiar Prefijo</span>
											</v-tooltip>
										</template>
										<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Cambiar Prefijo</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(prefix, index) in companyContractPrefixes"
													:key="index"
													dense
													@click="handleChangeContractPrefix(prefix.id)"
												>
													<v-list-item-title dense>
														{{ prefix.prefix }} - {{ prefix.name }}
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu>
								</div>
              </div>
            </div>

            <!-- Parent Contract Number -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="contract.parent_contract">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Contrato Asociado</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">
									{{ contract.serial_id }} - LP{{ contract.morphable?.project_line_info?.project_line?.number }} - {{ contract.parent_contract?.info?.prefix?.prefix }} {{ contract.parent_contract?.info?.contract_prefix_index }}
                </b>
              </div>
              <div class="action-container">
								<div>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												dark
												x-small
												color="warning"
												@click="toParentContractDetail(contract)"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<span>Ir al Contrato Asociado</span>
									</v-tooltip>
								</div>
              </div>
            </div>

            <!-- Project Name -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Proyecto</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">{{ project?.name }}</b>
              </div>
              <div class="action-container">
								<div v-if="!readOnlyMode">
									<ProjectLineAssociationMenu :projectLineAssociations="projectLineAssociations" :btnClick="() => selectRow(item)"/>
									<!-- <v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="warning"
												x-small
												icon
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<v-list dense class="py-0">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Asociaciones</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(association, index) in projectLineAssociations"
													:key="'ass-'+index"
													dense
													@click="handleGoTo(association)"
													style="min-width: 200px"
												>
													<v-list-item-title dense>
														<div class="d-flex justify-space-between align-center item-background-hover">
															<div class="d-flex justify-space-between caption" style="width: 100%">
																<div style="width: 90px">{{ association.type_name }}</div>
																<span>:</span>
																<b class="text-end" style="flex: 1;">#{{ association.morphable_id }}</b>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu> -->
								</div>
								<div>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												dark
												x-small
												color="warning"
												:disabled="!canEditInfo"
												@click="handleEditProjectData"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-pencil-outline</v-icon>
											</v-btn>
										</template>
										<span>Editar Datos Proyecto</span>
									</v-tooltip>
								</div>
              </div>
            </div>

            <!-- Project Zone -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Zona Proyecto</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">{{ project?.info?.zone?.name }}</b>
              </div>
              <div class="action-container">
                <v-menu 
                  v-model="zoneMenu" 
                  offset-y 
                  z-index="9999" 
                  :close-on-content-click="false" 
                  content-class="menu-bg-white"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="warning"
                      x-small
                      :disabled="!canEditInfo"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark small>mdi-swap-horizontal-bold</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
                    <v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
                      <p class="caption mb-0 font-weight-bold white--text">Cambiar Zona Proyecto</p>
                    </v-list-item>
                    <v-list-item-group color="#524D4D">
                      <v-list-item
                        v-for="(zone, index) in zones"
                        :key="index"
                        dense
                        @click="handleChangeIptZone(zone.id)"
                      >
                        <v-list-item-title dense>
                          {{ zone.name }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <!-- Project Type -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Tipo Proyecto</div>
                <span>:</span>
                <div class="d-flex flex-column align-end" style="flex: 1">
                  <p class="text-end text--disabled mb-0" style="font-size: 10px;line-height: 10px">
                    {{ projectTypeSubtitle }}
                  </p>
                  <b class="text-end" style="flex: 1;">
                    {{ projectTypeTitle }}
                  </b>
                </div>
              </div>
              <div class="action-container">
                <ProjectTypeSelectorMenu
                  :isDisabled="!canEditInfo"
                  :onClick="handleChangeProjectType"
                />
              </div>
            </div>

            <!-- Project Destiny -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Destino</div>
                <span>:</span>
                <div class="d-flex flex-column align-end" style="flex: 1">
                  <b class="text-end" style="flex: 1;">
                    {{ project?.info?.destiny?.name }}
                  </b>
                </div>
              </div>
              <div class="action-container">
                <ProjectDestinySelectorMenu
                  :isDisabled="!canEditInfo"
                  :onClick="handleChangeProjectDestiny"
                />
              </div>
            </div>

            <!-- Project Address -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Dirección Proyecto</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">{{ project?.info?.address?.address }}</b>
              </div>
              <div class="action-container"></div>
            </div>

            <!-- Municipality -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Municipio</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">{{ project?.info?.address?.district?.name }}</b>
              </div>
              <div class="action-container"></div>
            </div>

            <!-- Subcontratos de Tabla de Costo -->
            <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="contract?.subcontract_included_info">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 130px">Subcontratos Incluidos</div>
                <span>:</span>
                <div class="d-flex flex-column flex-grow-1 justify-end align-end text-right">
									<div
										v-for="(subcontract ,index) in contract.subcontract_included_info_persistent"
										:key="subcontract.item + '_' + subcontract.morphable_id + '_' + index">
										<div v-if="subcontract.subtitle">
											<p class="mb-0" style="font-size: 10px;">{{ subcontract.name }}</p>
											<b>{{subcontract.subtitle}}</b>
										</div>
										<b v-else>{{subcontract.name}}</b>
									</div>
								</div>
              </div>
              <div class="action-container"></div>
            </div>
          </div>
        </div>

        <v-divider vertical class="mx-4" v-if="$vuetify.breakpoint.width >= 750"></v-divider>

        <!-- Client Information Column -->
        <div class="flex-grow-1 client-column" :style="$vuetify.breakpoint.width < 750 ? 'width: 100%;' : ''">
          <div class="caption" v-if="contract">
            <!-- Responsible -->
            <div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
              <div class="d-flex justify-space-between caption" style="width: 100%">
                <div style="width: 100px">Responsable</div>
                <span>:</span>
                <b class="text-end" style="flex: 1;">{{ userResponsible || 'Sin Responsable' }}</b>
              </div>
              <div class="action-container">
                <v-menu 
                  v-model="responsibleMenu" 
                  offset-y 
                  z-index="9999" 
                  :close-on-content-click="false" 
                  content-class="menu-bg-white"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                        <v-btn
                          icon
                          color="warning"
                          x-small
                          :disabled="!canAssignResponsible"
                          v-bind="{ ...attrs, ...tooltipAttrs }"
                          v-on="{ ...on, ...tooltipOn }"
                        >
                          <v-icon dark small>mdi-swap-horizontal-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>Cambiar Responsable</span>
                    </v-tooltip>
                  </template>
                  <v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
                    <v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
                      <p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
                    </v-list-item>
                    <v-list-item-group color="#524D4D">
                      <v-list-item
                        v-for="(responsible, index) in usersList"
                        :key="index"
                        dense
                        @click="handleChangeResponsible(responsible.id)"
                      >
                        <v-list-item-title dense>
                          <div class="d-flex align-center">
                            <img 
                              :src="responsible.profile.avatar" 
                              class="user-avatar mr-2" 
                              v-if="responsible?.profile?.avatar"
                            />
                            <v-icon v-else class="user-avatar icon mr-2" color="#524D4D">
                              mdi-account
                            </v-icon>
                            <div>
                              <p class="mb-0">
                                {{ responsible.profile?.name }} 
                                {{ responsible.profile?.lastname }} 
                                {{ responsible.profile?.second_lastname }}
                              </p>
                              <p class="mb-0 caption">{{ responsible.email }}</p>
                            </div>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </div>
            </div>

						<ProjectHeaderInfoClientSubcontractorInfo :contract="contract" :project="project" :is_subcontract="is_subcontract"/>

						<div>
							<!-- Contract Value -->
							<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!contract.addendum_to_contract_id && !contract.subcontract_to_contract_id && !isSubcontractor">
								<div class="d-flex justify-space-between caption" style="width: 100%">
									<div style="width: 100px">Valor Contrato</div>
									<span>:</span>
									<b class="text-end" style="flex: 1;" v-if="contractValueComputed && contractValueComputed != 0">
										${{ contractValueComputed | toThousandFilter }}
									</b>
									<b class="text-end" style="flex: 1;" v-else>
										Sin valor asignado
									</b>
								</div>
								<div class="action-container justify-center">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#FF120B"
												icon
												class="mb-0"
												small
												v-if="canEditContractValue"
												v-bind="attrs"
												v-on="on"
												@click="handleChangePaymentRequired"
											>
												<v-icon small>
													{{ contractPaymentRequired ? 'mdi-square-rounded' : 'mdi-square-rounded-outline' }}
												</v-icon>
											</v-btn>
										</template>
										<span>Contrato Requiere Pago</span>
									</v-tooltip>

									<div>
										<v-menu
											v-model="contractValueMenu"
											:close-on-content-click="false"
											offset-y
										>
											<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
												<v-tooltip bottom>
													<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
														<v-btn
															depressed
															color="#959595"
															class="mb-0 ml-0"
															x-small
															icon
															v-bind="{ ...tooltipAttrs, ...menuAttrs }"
															v-on="{ ...tooltipOn, ...menuOn }"
														>
															<v-icon small>mdi-email-arrow-right</v-icon>
														</v-btn>
													</template>
													<span>Enviar correo para pago</span>
												</v-tooltip>
											</template>
											<v-card style="min-width: 150px;">
												<v-card-text class="pa-0">
													<div class="px-2 py-1" style="background: #959595;">
														<p class="caption mb-0 font-weight-bold white--text">
															Enviar Correo para Pago - Valor de Contrato
														</p>
													</div>
													<div class="pa-2">
														<div>
															<p class="caption mb-3 font-weight-bold" v-if="contract.info && contract.info.contract_value">
																El contrato tiene un valor asociado, puedes cambiarlo si lo deseas.
															</p>
															<p class="caption mb-3 font-weight-bold" v-else>
																El contrato no tiene un valor asociado, puedes asignarle un nuevo valor a continuación.
															</p>
															<v-text-field
																label="Valor del Contrato"
																v-model="localContractValue"
																class="custom-height-search custom-height-calendar mb-2"
																hide-details
																dense
																outlined
																type="number"
																@keypress="isNumberKey"
																:rules="requiredRule"
															></v-text-field>
															<v-btn
																depressed
																color="green"
																:dark="localContractValue"
																small
																block
																:disabled="!localContractValue"
																@click="handleSendPaymentRequestEmail"
															>
																<v-icon small>mdi-check</v-icon>
																<p class="mb-0 ml-2 caption">Confirmar</p>
															</v-btn>
															<v-btn
																depressed
																color="#959595"
																text
																x-small
																block
																class="mt-2"
																@click="contractValueMenu = false"
															>
																<p class="mb-0">Cancelar</p>
															</v-btn>
														</div>
													</div>
												</v-card-text>
											</v-card>
										</v-menu>
									</div>
								</div>
							</div>
						</div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ProjectTypeSelectorMenu from '@/components/Helpers/Components/ProjectTypeSelectorMenu'
import ProjectDestinySelectorMenu from '@/components/Helpers/Components/ProjectDestinySelectorMenu'
import contractStatuses from '@/components/Helpers/Constants/contract.js'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectHeaderInfoClientSubcontractorInfo from '@/components/Views/Projects/Parts/ProjectHeaderInfoClientSubcontractorInfo'
export default {
  name: 'ProjectHeaderInfo',
	components: {ProjectTypeSelectorMenu, ProjectDestinySelectorMenu, ProjectLineAssociationMenu, ProjectHeaderInfoClientSubcontractorInfo},
  props: {
		readOnlyMode: {
			type: Boolean,
			default: false
		},
    // Contract data
    is_subcontract: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    
    // UI State
    isScrolled: {
      type: Boolean,
      default: false
    },
    showDetailsHeader: {
      type: Boolean,
      default: true
    },
    
    // Permissions
    canEditInfo: {
      type: Boolean,
      default: false
    },
    canAssignResponsible: {
      type: Boolean,
      default: false
    },
    canEditClient: {
      type: Boolean,
      default: false
    },
    
    // Data arrays
    companyContractPrefixes: {
      type: Array,
      default: () => []
    },
    zones: {
      type: Array,
      default: () => []
    },
    usersList: {
      type: Array,
      default: () => []
    },
    projectLineAssociations: {
      type: Object,
      default: () => ({})
    },
    
    // User info
    userInfo: {
      type: Object,
      default: () => ({})
    },
    userResponsible: {
      type: String,
      default: ''
    },
    
    // Contract specific data
    canEditContractValue: {
      type: Boolean,
      default: false
    },
    contractValue: {
      type: [Number, String],
      default: null
    },
    contractPaymentRequired: {
      type: Boolean,
      default: false
    },
		projectTypeTitle: {
      type: String,
      default: ''
    },
    projectTypeSubtitle: {
      type: String,
      default: ''
    },
    toContractDetail: {
			type: Function
		},
    // Validation rules
    requiredRule: {
      type: Array,
      default: () => [v => !!v || 'Campo requerido']
    },
		hideContractStatus: {
			type: Boolean,
			default: false
		}
  },
  
  data() {
    return {
			contractStatuses,
      // Menu states
      prefixMenu: false,
      zoneMenu: false,
      responsibleMenu: false,
      userCompanyMenu: false,
      contractValueMenu: false,
      
      // Local contract value for editing
      localContractValue: null,
			localShowDetails: false,
			closeTimeout: null
    }
  },
  computed: {
    canSignCompany() {
      if (!this.contract) return false
      if (this.userInfo && this.selectedCompany && this.selectedCompany.company_id === this.contract.company_id) {
        return this.contract.last_status?.status === contractStatuses.FIRMADO_CONTRAPARTE &&
          this.selectedCompany.company?.responsible === this.userInfo.id
      }
      return false
    },
		showProjectDetails(){
			return this.localShowDetails && this.showDetailsHeader
		},
		isSubcontractor(){
			return this.$store.state.user.companyPermissions?.subcontractor === true
		},
		contractCode() {
			if(this.contract?.parent_contract){
				let append = ''
				if(this.contract.addendum_to_contract_id){
					append = ` - ANX Nº ${this.contract.addendum_index}`
				}
				else if(this.contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${this.contract.subcontract_index}`
				}
				return `${this.contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${this.contract.info?.prefix?.prefix} ${this.contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${this.contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${this.contract.info?.prefix?.prefix} ${this.contract.info?.contract_prefix_index}`
		},
    contractValueComputed() {
      return this.contractValue || this.contract?.info?.contract_value || 0
    },
		contractType() {
			if (this.contract?.addendum_to_contract_id) {
				return 'addendum'
			}
			if (this.contract?.subcontract_to_contract_id) {
				return 'subcontract'
			}
			return 'contract'
		},
		contractTypeText() {
			if (this.contract?.addendum_to_contract_id) {
				return 'Anexo'
			}
			if (this.contract?.subcontract_to_contract_id) {
				return 'Subcontrato'
			}
			return 'Contrato'
		},
		isAddendum() {
			return this.contractType === 'addendum'
		},
		isSubcontract() {
			return this.contractType === 'subcontract'
		},
    isCreatedStatus() {
      return this.contract?.last_status?.status === this.contractStatuses?.CREADO
    },
		canDeleteAddendum(){
			return this.contract.last_status?.status != this.contractStatuses.ACEPTADO && this.contract.last_status?.status != this.contractStatuses.FIRMADO_CONTRAPARTE && this.contract.last_status?.status != this.contractStatuses.FIRMADO_AMBAS_PARTES
		},
		statusNotice() {
			if(this.isAddendum){
				return this.$options.filters.addendumStatusNotice(this.contract.last_status?.status) || ''
			}
			else if(this.isSubcontract){
				return this.$options.filters.subcontractStatusNotice(this.contract.last_status?.status) || ''
			}
			return this.$options.filters.contractEstatusNotice(this.contract.last_status?.status) || ''
		},
  },
  
  watch: {
    contractValue: {
      immediate: true,
      handler(newVal) {
        this.localContractValue = newVal
      }
    }
  },
  
  methods: {
		toggleShowDetail(){
			this.localShowDetails = !this.localShowDetails
		},
		openUserCompanyMenu(){
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
			this.userCompanyMenu = true
		},
    closeMenuWithDelay() {
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
      this.closeTimeout = setTimeout(() => {
        this.userCompanyMenu = false
        this.closeTimeout = null
      }, 150)
    },
		toParentContractDetail(child_contract){
			this.$store.commit('contracts/setContractComponentModalId', child_contract.parent_contract?.id)
		},
    // Event handlers - emit events to parent
    handleChangeContractPrefix(prefixId) {
      this.prefixMenu = false
      this.$emit('change-contract-prefix', prefixId)
    },
    
    handleEditProjectData() {
      this.$emit('edit-project-data')
    },
    
    handleGoTo(association) {
      this.$emit('go-to', association)
    },
    
    handleChangeIptZone(zoneId) {
      this.zoneMenu = false
      this.$emit('change-ipt-zone', zoneId)
    },
    
    handleChangeProjectType(projectType) {
      this.$emit('change-project-type', projectType.id)
    },

		handleChangeProjectDestiny(projectDestiny) {
			this.$emit('change-project-destiny', projectDestiny.id)
		},
    
    handleChangeResponsible(responsibleId) {
      this.responsibleMenu = false
      this.$emit('change-responsible', responsibleId)
    },
    
    handleEditUser() {
      this.$emit('edit-user')
    },
    
    handleChangePaymentRequired() {
      this.$emit('change-payment-required')
    },
    
    handleSendPaymentRequestEmail() {
      this.contractValueMenu = false
      this.$emit('send-payment-request-email', this.localContractValue)
    },
    
    // Utility methods
    isNumberKey(event) {
      const charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault()
      }
    }
  }
}
</script>

<style scoped>
.budget-modal-card {
  background-color: white;
  text-transform: none;
  border-radius: 8px;
}

.item-background-hover:hover {
  background-color: #f5f5f5;
  border-radius: 4px;
}
.action-container{
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.item-background-hover:hover .action-container {
  opacity: 1;
}

.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.user-avatar.icon {
  width: 24px;
  height: 24px;
}

.client-column {
  min-width: 300px;
}

.custom-height-search {
  font-size: 12px;
}

.custom-height-calendar /deep/ .v-input__control {
  min-height: 32px;
}

.menu-bg-white {
  background-color: white !important;
}

.section-container {
  border: 1px solid #d3d3d3;
}

.section-content-container {
  position: relative;
  text-transform: none;
}

/deep/ .section-content-container p,
/deep/ .section-content-container div,
/deep/ .section-content-container ul,
/deep/ .section-content-container span,
/deep/ .section-content-container {
  text-transform: none;
}

/deep/ .section-content-container img {
  max-width: 100%;
  object-fit: contain;
}

/deep/ .section-content p {
  margin-bottom: 0;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.3); }
  100% { transform: scale(1); }
}

.pulse-animation {
  animation: pulse 1.5s infinite;
}

.project-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.project-type-badge {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9e9a9a;
  flex-shrink: 0;
}

.project-info {
  flex: 1;
  border-left: 1px solid #e0dcdc;
  padding-left: 12px;
}

.project-code {
  font-size: 16px;
  font-weight: 700;
  color: #2c2828;
  line-height: 1.3;
}

.project-name {
  font-size: 12px;
  color: #7a7575;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  background: transparent;
  border: 1px solid #d6d1d1;
  border-radius: 4px;
  cursor: pointer;
  color: #524D4D;
  font-size: 13px;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.toggle-btn:hover {
  background: #eeebeb;
  border-color: #524D4D;
}

.status-notice-box {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #FB8C00;
  border-left: 3px solid #FB8C00;
  border-radius: 4px;
  padding: 4px 10px;
  flex: 1;
  min-width: 0;
}

.status-notice-text {
  color: #FB8C00;
}
</style>